/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc
 */
import * as References from './ServiceCatalogServiceRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServices
 */
export const GET_SERVICES_QUERY_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServices';
export const GET_SERVICES_QUERY: RegisteredQuery<
  'result',
  References.GetServicesRequestType,
  References.GetServicesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SERVICES_QUERY_FIELD_NAME,
  args: ['categoryId', 'apiName', 'active', 'language', 'includeAllLanguages'],
  fetcher(
    request: References.GetServicesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetServicesResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getServicesRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServiceById
 */
export const GET_SERVICE_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServiceById';
export const GET_SERVICE_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetServiceByIdRequestType,
  References.GetServiceByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SERVICE_BY_ID_QUERY_FIELD_NAME,
  args: ['id', 'language', 'includeAllLanguages'],
  fetcher(
    request: References.GetServiceByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetServiceByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getServiceByIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServicesPaged
 */
export const GET_SERVICES_PAGED_QUERY_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServicesPaged';
export const GET_SERVICES_PAGED_QUERY: RegisteredQuery<
  'result',
  References.GetServicesPagedRequestType,
  References.GetServicesPagedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SERVICES_PAGED_QUERY_FIELD_NAME,
  args: [
    'categoryId',
    'apiName',
    'active',
    'language',
    'includeAllLanguages',
    'after',
    'before',
    'limit',
  ],
  fetcher(
    request: References.GetServicesPagedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetServicesPagedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getServicesPagedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServicesByIds
 */
export const GET_SERVICES_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServicesByIds';
export const GET_SERVICES_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetServicesByIdsRequestType,
  References.GetServicesByIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SERVICES_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids', 'language', 'includeAllLanguages'],
  fetcher(
    request: References.GetServicesByIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetServicesByIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getServicesByIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#createService
 */
export const CREATE_SERVICE_MUTATION_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_createService';
export const CREATE_SERVICE_MUTATION: RegisteredQuery<
  'result',
  References.CreateServiceRequestType,
  References.CreateServiceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_SERVICE_MUTATION_FIELD_NAME,
  args: [
    'active',
    'name',
    'description',
    'translationKey',
    'categoryId',
    'brief',
    'apiName',
    'credentials',
  ],
  fetcher(
    request: References.CreateServiceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateServiceResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.createServiceRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#updateService
 */
export const UPDATE_SERVICE_MUTATION_FIELD_NAME =
  'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_updateService';
export const UPDATE_SERVICE_MUTATION: RegisteredQuery<
  'result',
  References.UpdateServiceRequestType,
  References.UpdateServiceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_SERVICE_MUTATION_FIELD_NAME,
  args: ['id', 'active', 'brief', 'description', 'apiName', 'credentials'],
  fetcher(
    request: References.UpdateServiceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateServiceResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.updateServiceRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
